export const iconSizes = {
  small: '16px',
  medium: '20px',
  large: '24px',
};
